<template>
  <footer>
    <div class="w-full mt-16">
      <div class="container flex justify-between pb-3 xl:pb-6">
        <div>
          <a
            v-if="!loading"
            href="#"
            class="inline-flex items-center text-sm transition-colors duration-300 ease-in-out cursor-pointer text-sw_yellow_error-text hover:underline xl:text-base hover:text-sw_gray-700"
            @click.prevent="showExitPopup = true"
          >
            <div class="w-1.5 mr-2">
              <svg viewBox="0 0 4 6.668" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 3.335l4 3.333V0z" fill="#c00" data-name="Path 714"/></svg>
            </div>
            {{ $t('components.footer.returnToLH') }}
          </a>
        </div>

        <CancelRedemptionPopup v-model="showExitPopup" />
      </div>

      <div class="py-4 border-t border-sw_gray-300 xl:py-6 text-sw_gray-600">
        <div class="container flex flex-col items-center text-center xl:text-left xl:flex-row xl:justify-between">
          <div class="flex flex-col items-center pb-4 xl:pb-0 xl:flex-row">
            <div class="logo" />

            <div class="pt-2 text-sm xl:pt-0 xl:ml-5">
              © Swiss International Air Lines
            </div>
          </div>
          <nav>
            <ul class="text-center xl:flex xl:justify-start">
              <li class="pb-2 leading-tight truncate xl:pb-0 xl:mr-8">
                <a
                  target="_blank"
                  :href="imprintLink"
                  class="transition-colors duration-300 ease-in-out text-sw_yellow_error-text hover:text-sw_gray-700 hover:underline"
                >
                  {{ $t('components.footer.links.imprint') }}
                </a>
              </li>
              <li class="pb-2 leading-tight truncate xl:pb-0 xl:mr-8">
                <a
                  target="_blank"
                  :href="privacyLink"
                  class="transition-colors duration-300 ease-in-out text-sw_yellow_error-text hover:text-sw_gray-700 hover:underline"
                >
                  {{ $t('components.footer.links.privacy') }}
                </a>
              </li>
              <li class="leading-tight truncate">
                <a
                  target="_blank"
                  :href="termsLink"
                  class="transition-colors duration-300 ease-in-out text-sw_yellow_error-text hover:text-sw_gray-700 hover:underline"
                >
                  {{ $t('components.footer.links.termsOfUse') }}
                </a>
              </li>
            </ul>
          </nav>
          <div class="w-56 mt-4 xl:mt-0">
            <img src="~images/psp/swiss/logo/star-alliance.svg">
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import Vue from 'vue'
import { mixin as clickaway } from 'vue-clickaway'
import CancelRedemptionPopup from '~app/psp/swiss/cancel-redemption-popup.vue'

export default Vue.extend({
  components: {
    CancelRedemptionPopup,
  },

  mixins: [clickaway],

  data(): {
    showExitPopup: boolean;
  } {
    return {
      showExitPopup: false,
    }
  },
  computed: {
    linkLanguage(): string {
      if (['de', 'fr', 'it'].includes(this.$i18n.locale)) {
        return this.$i18n.locale
      }

      return 'en'
    },
    imprintLink(): string {
      return `https://www.swiss.com/xx/${this.linkLanguage}/terms-conditions/imprint`
    },
    privacyLink(): string {
      return `https://www.swiss.com/xx/${this.linkLanguage}/terms-conditions/privacy-statement`
    },
    termsLink(): string {
      return `https://www.swiss.com/xx/${this.linkLanguage}/book-and-manage/conditions/voucher-conditions-overview.html`
    },
    loading(): boolean {
      return this.$store.state.redemptions.loading
    },
  },
})
</script>

<style lang="scss" scoped>
.logo {
  width: 129px;
  height: 30px;
  background: url('~images/psp/swiss/logo/logo-primary.svg') 0 0 / 129px 30px no-repeat;
}
</style>
